var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"knowledge"}},[_c('v-container',{attrs:{"grid-list-xl":"","px-4":""}},[_c('KnowldgeCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }